import { render, staticRenderFns } from "./childDomainConfig.vue?vue&type=template&id=dabdbe98&scoped=true&"
import script from "./childDomainConfig.vue?vue&type=script&lang=js&"
export * from "./childDomainConfig.vue?vue&type=script&lang=js&"
import style0 from "./childDomainConfig.vue?vue&type=style&index=0&id=dabdbe98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabdbe98",
  null
  
)

export default component.exports